<div class="box custom-box h-full flex flex-col">
  <div class="box-header">
    <div class="box-title">Usuários por Grupo</div>
  </div>
  <div class="box-body !p-0 flex-1 flex flex-col">
    <!-- Loading State -->
    <div *ngIf="loading" class="flex items-center justify-center p-8">
      <app-loading-spinner message="Carregando grupos..."></app-loading-spinner>
    </div>

    <!-- Error State -->
    <div *ngIf="error && !loading" class="flex items-center justify-center p-8">
      <div class="text-center text-danger">
          <div class="flex items-center gap-2 mb-4">
              <i class="ri-error-warning-line text-xl"></i>
              <p class="!mt-1">Erro ao carregar dados dos grupos</p>
          </div>
          <button class="ti-btn ti-btn-primary-full !py-1 !px-2 ti-btn-wave" (click)="loadUsersByGroup()">
              <i class="ri-refresh-line"></i>
              Tentar Novamente
          </button>
      </div>
  </div>

    <!-- Success State - Distributed Columns Chart -->
    <div *ngIf="!loading && !error && hasData" id="users-by-group-chart" class="flex-1">
      <apx-chart [series]="chartOptions.series!" [chart]="chartOptions.chart!" [dataLabels]="chartOptions.dataLabels!"
        [plotOptions]="chartOptions.plotOptions!" [xaxis]="chartOptions.xaxis!" [legend]="chartOptions.legend!"
        [colors]="chartOptions.colors!" [grid]="chartOptions.grid!"></apx-chart>
    </div>

    <!-- Empty State - No groups created -->
    <div *ngIf="!loading && !error && !hasGroups" class="flex-1 flex items-center justify-center p-8">
      <div class="text-center text-gray-500">
        <i class="ri-group-line text-4xl mb-3 block"></i>
        <p class="font-semibold text-sm mb-1">Nenhum grupo criado ainda</p>
        <p class="text-xs">O gráfico será exibido quando houver grupos cadastrados.</p>
      </div>
    </div>

    <!-- Empty State - Groups exist but no users -->
    <div *ngIf="!loading && !error && hasGroups && !hasData" class="flex-1 flex items-center justify-center p-8">
      <div class="text-center text-gray-500">
        <i class="ri-group-line text-4xl mb-3 block"></i>
        <p class="font-semibold text-sm mb-1">Grupos sem usuários</p>
        <p class="text-xs">O gráfico será exibido quando houver usuários vinculados aos grupos.</p>
      </div>
    </div>
  </div>
</div>